import ReactDOM from 'react-dom';

import './App';

import Routers from './Routers';

ReactDOM.render(Routers, document.getElementById('root'));
